import * as React from 'react'
import * as Types from '../declarations'

import { VersionContext } from '../contexts/VersionContext'

interface Props {
	size?: number
	label?: string
}

// Standard site loading indicator: the brand mark (mountain + sun, icon only)
// with a gentle pulse. Version-aware: Peaks logo on Peaks, Trekking mark on
// Trekking — same pattern the Header uses for its logo.
const BrandLoader = ({ size = 72, label }: Props) => {
	const version = React.useContext(VersionContext)?.version

	return (
		<div className="brand-loader" role="status" aria-live="polite">
			<img
				className="brand-loader-logo"
				src={
					version === Types.VERSION.PEAKS
						? '/branding/peaks-logo-mark-160.png'
						: '/branding/trekking-logo-mark-160.jpg'
				}
				alt=""
				width={size}
				height={size}
			/>
			{label ? <span className="brand-loader-label">{label}</span> : null}
		</div>
	)
}

export default BrandLoader
